import React from 'react';
import mixpanel from 'mixpanel-browser';

const MixpanelContext = React.createContext(mixpanel);

export default MixpanelContext;
